import axios from "@/widgets/shared/utils/axios-instance";

export const types = {
  LOAD_ATTENDEES: "loadAttendees",
  LOAD_ATTENDEES_SUCCESS: "loadAttendeesSuccess",
  LOAD_ATTENDEES_ERROR: "loadAttendeesError",
  LOAD_ATTENDEES_CLEAR_ERROR: "loadAttendeesClearError",
};

export function state() {
  return {
    status: null,
    error: null,
    totalCount: {},
    attendees: {},
    loadedAgendaSessionIds: [],
  };
}

export const mutations = {
  async setAttendees(state, {attendees, totalCount, agendaSessionId}) {
    const attendeesClone = {...state.attendees};
    attendeesClone[agendaSessionId] = attendees;
    state.attendees = attendeesClone;

    const totalCountClone = {...state.totalCount};
    totalCountClone[agendaSessionId] = totalCount;
    state.totalCount = totalCountClone;

    state.loadedAgendaSessionIds = [...state.loadedAgendaSessionIds, agendaSessionId];
  },

  async appendAttendee(state, {attendee, agendaSessionId}) {
    state.attendees[agendaSessionId] = {...state.attendees[agendaSessionId], attendee};
  },

  async removeAttendees(state, agendaSessionId) {
    state.attendees[agendaSessionId] = [];
    state.totalCount[agendaSessionId] = [];
    state.loadedAgendaSessionIds = state.loadedAgendaSessionIds.filter(id => id !== agendaSessionId);
  },

  async removeAttendee(state, {userId, agendaSessionId}) {
    if (state.attendees[agendaSessionId]) {
      const filteredAttendees = state.attendees[agendaSessionId].filter(attendee => attendee.user_identity_token !== userId);
      state.attendees[agendaSessionId] = filteredAttendees;
    }
  },

  [types.LOAD_ATTENDEES](state, agendaSessionId) {
    state.status = agendaSessionId;
  },
  [types.LOAD_ATTENDEES_SUCCESS](state) {
    state.status = null;
  },
  [types.LOAD_ATTENDEES_ERROR](state, error) {
    state.error = error;
  },
  clearAttendeesError(state) {
    state.error = null;
  },

  clearAttendees(state) {
    state.status = null;
    state.totalCount = {};
    state.attendees = {};
    state.loadedAgendaSessionIds = [];
  }
};

export const actions = {
  async loadAttendeesFromSession({commit, rootState, getters}, {agendaSessionId, force}) {
    if ((rootState.token && getters["attendeesCountFromSession"](agendaSessionId) === 0) || force) {
      commit(types.LOAD_ATTENDEES, agendaSessionId);
      const eventId = rootState.eventId;
      const params = {
        limit: 7,
      };
      await axios
        .get(`events/${eventId}/attendance/agenda_sessions/${agendaSessionId}`, {
          params: params,
        })
        .then(result => {
          const attendees = result.data.users;
          const totalCount = result.data.meta.all_items;
          commit("setAttendees", {attendees, totalCount, agendaSessionId});
          commit(types.LOAD_ATTENDEES_SUCCESS);
        })
        .catch(err => {
          commit(types.LOAD_ATTENDEES_ERROR, err);
        });
    }
  },
};

export const getters = {
  attendeesFromSession: state => agendaSessionId => {
    return state.attendees[agendaSessionId] || [];
  },

  attendeesCountFromSession: state => agendaSessionId => {
    return state.totalCount[agendaSessionId] || 0;
  },

  isLoading: state => agendaSessionId => state.status === agendaSessionId,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
